import { ModalCustom } from "components/ModalCustom";
import { Icone, ModalBody } from "./style";
import { FaCheck } from "react-icons/fa";

interface IProps {
  show: boolean;
  handleClose: () => void;
  tipo: "bloquear" | "desbloquear";
}

export function ModalSucessoSalvarLote({ show, handleClose, tipo }: IProps) {
  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title={tipo === "bloquear" ? "Bloquear veículos" : "Desbloquear veículos"}
      centered={true}
      footer={false}
      footerConfirmButton={false}
    >
      <ModalBody>
        <Icone>
          <FaCheck />
        </Icone>
        Solicitação enviada com sucesso!
      </ModalBody>
    </ModalCustom>
  );
}
